import React from 'react';
import './GalleryDeleteComponent.css';

interface GalleryDeleteComponentProps {
  albums: any[];
  goalId?: string;
  onDelete: (key: number, id: string) => void;
}

const GalleryDeleteComponent: React.FC<GalleryDeleteComponentProps> = ({ albums, onDelete }) => {
  if (!albums || albums.length === 0) {
    return (
      <div className="gallery-delete-empty">
        <p>No photos available for deletion</p>
      </div>
    );
  }

  return (
    <div className="gallery-delete-container">
      <div className="gallery-delete-grid">
        {albums.map((album, index) => (
          <div key={index} className="gallery-delete-item">
            <div className="gallery-delete-image-container">
              <img 
                src={album.url || album} 
                alt={`Photo ${index + 1}`}
                className="gallery-delete-image"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
              />
              <div className="gallery-delete-overlay">
                <button 
                  className="gallery-delete-button"
                  onClick={() => onDelete(index, album.id || index.toString())}
                  title="Delete photo"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>      
    </div>
  );
};

export default GalleryDeleteComponent;
